<template>
  <CustomDeleteDialog
    :dialogTitle="`حذف نقش ${selectedRoleTitle}`"
    dialogId="delete-role-confirmation-dialog"
    no-close-on-backdrop
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendRoleDeleteRequest"
  >
    <BCol cols="12" v-if="selectedRole">
      <p>
        آیا از حذف نقش
        <span class="font-weight-bolder">
          {{ selectedRoleTitle }}
        </span>
        اطمینان دارید؟
      </p>
    </BCol>
  </CustomDeleteDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  props: {
    selectedRole: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async sendRoleDeleteRequest() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let deleteAUserType = new DeleteAUserType(_this);
        deleteAUserType.setRequestParam({ id: _this.selectedRole.userTypeId });
        await deleteAUserType.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "نقش با موفقیت حذف شد!",
              },
            });
            _this.$emit("refetch");
            _this.$bvModal.hide("delete-role-confirmation-dialog");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.message || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  computed: {
    selectedRoleTitle() {
      if (this.selectedRole && this.selectedRole.title) {
        return this.selectedRole.title;
      }
      return "";
    },
  },
  components: {
    CustomDeleteDialog,
    BCol,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { DeleteAUserType } from "@/libs/Api/UserType";
import { BCol } from "bootstrap-vue";
</script>
